export default "__VITE_ASSET__DSRw5FZx__"